import { getElements } from '../../../../Resources/Private/TypeScript/Utility/Dom'

declare global {
  interface Window {
    n2g?: {
      (...args: unknown[]): void
      l?: number
      q?: unknown[][]
    }
    Newsletter2GoTrackingObject?: string
  }
}

class Newsletter {
  private config: object = {
    'columnLeft': { 'class': '', 'style': '', 'type': 'div' },
    'columnRight': { 'class': '', 'style': '', 'type': 'div' },
    'container': { 'class': '', 'style': '', 'type': 'div' },
    'label': { 'class': '', 'style': '', 'type': 'label' },
    'row': { 'class': '', 'style': 'margin-top: 15px', 'type': 'div' }
  }
  private items: NodeListOf<HTMLElement>

  constructor() {
    this.items = getElements('newsletter')
  }

  public init (): void {
    if (this.items.length === 0) return

    this.loadTrackingScript()

    this.items.forEach((item: HTMLElement): void => {
      window.n2g('create', item.getAttribute('data-id'))
      window.n2g('subscribe:createForm', this.config, item.getAttribute('id'))
    })
  }

  private loadTrackingScript(): void {
    const e = window
    const t = document
    const c = 'https://static.newsletter2go.com/utils.js'
    const r = 'n2g'

    e.Newsletter2GoTrackingObject = r
    e[r] = e[r] || ((...args): void => {
      (e[r].q = e[r].q || []).push(args)
    })
    e[r].l = new Date().getTime()

    const a = t.createElement('script')
    const i = t.getElementsByTagName('script')[0]
    a.async = true
    a.src = c
    i.parentNode.insertBefore(a, i)
  }
}

const newsletter = new Newsletter()
newsletter.init()
